<span [innerHTML]="this.icon" class="svg-icons"></span>
